import React from 'react';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
  matchPath,
} from 'react-router-dom';
import routes from "./routes";
import Layout from "./containers/Layout/Layout";
import jwt from 'jsonwebtoken';
// import MaintenancePageMobile from "./containers/Miscellaneous/MaintenancePageMobile";
import 'bootstrap';
import './assets/sass/app.scss';
import 'bootstrap-daterangepicker/daterangepicker.css';

import OneSignal from 'react-onesignal';
import { useEffect } from 'react';

// import "bootstrap/dist/js/bootstrap.min.js";


function App() {

    useEffect(() => {
        const appId = process.env.REACT_APP_ENV === "staging"
          ? process.env.REACT_APP_ONE_SIGNAL_KEY
          : process.env.REACT_APP_ONE_SIGNAL_LIVE_KEY;

        if (!appId) {
          return;
        }

        OneSignal.init({
          appId,
           promptOptions: {
            slidedown: {
              enabled: true,
              actionMessage: "Subscribe to our notifications for the latest news and updates. You can disable anytime.",
              acceptButtonText: "Subscribe",
              cancelButtonText: '',
          } 
        }
        });
    }, []);
    
  return (
    // <MaintenancePageMobile/>
    <Router>
      <Switch>
        <Route
          path="/"
          render={(props) => {

              const currentPath = window.location.pathname;
              const matchedRoute = routes.find(route =>  matchPath(currentPath, { path: route.path, exact: route.exact || false }));
              const requireAuth = matchedRoute?.requireAuth || false;
              
              if (requireAuth) 
              {
                  const accessToken = localStorage.getItem('accessToken');
                  const publicKey = process.env[`REACT_APP_${process.env.REACT_APP_ENV.toUpperCase()}_PUBLIC_KEY`];
                  let isAuthenticated = false;

                  if (accessToken) {
                      try {
                          jwt.verify(accessToken, publicKey, { algorithms: ['RS256'] });
                          isAuthenticated = true;
                      } catch (error) {
                          isAuthenticated = false;
                      }
                  }
                  
                  if (!isAuthenticated) 
                  {
                      return <Redirect to="/" />
                  }
              }

              return <Route path="/" name="Home" render={props => <Layout {...props}/>}/>;
          }}
        />
      </Switch>
    </Router>
  );

}

export default App;
